import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPedidoByPaymentIntent } from "../../../services/cliente/stripe";
import "./CheckoutSuccess.css";

function CheckoutSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const paymentIntentId = location.state?.payment_intent_id || null;

  const [loading, setLoading] = useState(true);
  const [pedidoId, setPedidoId] = useState(null);
  const [noPo, setNoPo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!paymentIntentId) {
      setError("Missing payment reference.");
      setLoading(false);
      return;
    }

    let cancelled = false;
    let tries = 0;
    let timeoutId = null;
    const maxTries = 12;

    const poll = async () => {
      try {
        tries += 1;

        const data = await getPedidoByPaymentIntent(paymentIntentId);
        if (cancelled) return;

        if (data?.pedido_id) {
          setPedidoId(data.pedido_id);
          setNoPo(data.no_po || null);
          setLoading(false);
          return;
        }

        if (tries >= maxTries) {
          setError(
            "Payment confirmed, but the order is still being generated. Please check your orders in a moment."
          );
          setLoading(false);
          return;
        }

        timeoutId = setTimeout(poll, 2000);
      } catch (e) {
        if (cancelled) return;

        const status = e?.response?.status;

        if (status === 404) {
          if (tries >= maxTries) {
            setError(
              "Payment confirmed, but the order is still being generated. Please check your orders in a moment."
            );
            setLoading(false);
            return;
          }
          timeoutId = setTimeout(poll, 2000);
          return;
        }

        setError(e?.response?.data?.message || "Unable to load order details.");
        setLoading(false);
      }
    };

    poll();

    return () => {
      cancelled = true;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [paymentIntentId]);

  const title = loading
    ? "Processing your order…"
    : error
    ? "Payment received"
    : "Payment successful";

  return (
    <div className="checkout-success-wrapper">
      <div className="checkout-success-card">
        <div className="checkout-success-icon">✔</div>

        <h1 className="checkout-success-title">{title}</h1>

        {loading ? (
          <div className="checkout-success-cargando">
            <div className="adc-spinner" />
            <p className="checkout-success-text">
              Payment confirmed. We&apos;re generating your order now…
            </p>
          </div>
        ) : error ? (
          <p className="checkout-success-text">{error}</p>
        ) : (
          <p className="checkout-success-text">
            Your order <strong>#{pedidoId}</strong> has been created
            {noPo ? (
              <>
                {" "}
                with PO number <strong>{noPo}</strong>.
              </>
            ) : (
              "."
            )}
          </p>
        )}

        <div className="checkout-success-actions">
          <button
            className="checkout-success-btn outline"
            onClick={() => navigate("/store/login")}
          >
            View my orders
          </button>

          <button
            className="checkout-success-btn primary"
            onClick={() => navigate("/")}
          >
            Continue shopping
          </button>
        </div>
      </div>
    </div>
  );
}

export default CheckoutSuccess;
